"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function DevLogsConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  const rotations = ["-rotate-2", "rotate-1", "-rotate-1"];
  const tapeRotations = ["-rotate-12", "rotate-6"];
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
        {[0, 1, 2].map(i => <div key={i} data-index={i} className="bg-card border-[3px] border-border rounded-md p-3.5 pb-14 animate-pulse" style={{
        boxShadow: "6px 6px 0 var(--border)"
      }}>
            <div className="aspect-[4/3] bg-muted/40 mb-4" />
            <div className="h-3 bg-muted/40 w-1/3 mb-3" />
            <div className="h-5 bg-muted/40 w-4/5 mb-2" />
            <div className="h-5 bg-muted/40 w-3/5" />
          </div>)}
      </div>;
  }
  if (error || posts.length === 0) {
    return <p className="font-mono text-sm uppercase tracking-widest text-muted-foreground">
        No articles found.
      </p>;
  }
  const displayPosts = posts.slice(0, 3);
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 lg:gap-12">
      {displayPosts.map((post, i) => {
      const date = post.date ? new Date(post.date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit"
      }) : "";
      return <article data-index={i} key={post.id} className={`group relative bg-card border-[3px] border-border rounded-md p-3.5 pb-14 transition-transform duration-300 ease-out ${rotations[i % 3]} hover:rotate-0`} style={{
        boxShadow: "6px 6px 0 var(--border)",
        transitionProperty: "transform, box-shadow"
      }} onMouseEnter={e => {
        e.currentTarget.style.boxShadow = "10px 10px 0 var(--primary)";
      }} onMouseLeave={e => {
        e.currentTarget.style.boxShadow = "6px 6px 0 var(--border)";
      }}>
            {}
            <div className={`absolute -top-3 left-4 w-16 h-6 bg-primary/80 ${tapeRotations[0]} z-10`} style={{
          backgroundImage: "repeating-linear-gradient(45deg, transparent 0 2px, hsl(0 0% 100% / 0.08) 2px 4px)"
        }} aria-hidden="true" />
            <div className={`absolute -top-3 right-4 w-16 h-6 bg-primary/80 ${tapeRotations[1]} z-10`} style={{
          backgroundImage: "repeating-linear-gradient(45deg, transparent 0 2px, hsl(0 0% 100% / 0.08) 2px 4px)"
        }} aria-hidden="true" />

            {}
            <div className="relative aspect-[4/3] border-2 border-border overflow-hidden bg-muted">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" /> : <div className="w-full h-full bg-muted flex items-center justify-center">
                  <span className="font-serif text-4xl text-muted-foreground" style={{
              fontFamily: "var(--font-serif)"
            }}>
                    VPN
                  </span>
                </div>}
            </div>

            {}
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
              § {date}
            </p>

            {}
            <h3 className="mt-2 font-default text-lg md:text-xl font-bold leading-tight text-foreground line-clamp-2" style={{
          fontFamily: "var(--font-sans)",
          letterSpacing: "-0.01em"
        }}>
              {post.title}
            </h3>

            {}
            <Link to={post.link || "#"} className="absolute bottom-4 left-4 right-4 inline-flex items-center justify-center">
              <span className="relative inline-flex items-center gap-1.5 bg-primary text-primary-foreground border-2 border-primary rounded-md px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.15em] font-semibold">
                {}
                <span className="absolute -top-1 -left-1 w-2 h-2 border-l-2 border-t-2 border-primary" aria-hidden="true" />
                <span className="absolute -top-1 -right-1 w-2 h-2 border-r-2 border-t-2 border-primary" aria-hidden="true" />
                <span className="absolute -bottom-1 -left-1 w-2 h-2 border-l-2 border-b-2 border-primary" aria-hidden="true" />
                <span className="absolute -bottom-1 -right-1 w-2 h-2 border-r-2 border-b-2 border-primary" aria-hidden="true" />
                Read More
                <ArrowRight className="size-3" />
              </span>
            </Link>
          </article>;
    })}
    </div>;
}
export default function RelatedArticlesGrid() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  const tickerItems = ["SECURE BROWSING", "GLOBAL SERVERS", "NO-LOGS POLICY", "FAST SPEEDS", "ENCRYPTED DATA", "PRIVACY FIRST"];
  return <section data-section-id="1190" id="relatedarticlesgrid" className="relative bg-background text-foreground py-28 md:py-40 overflow-hidden">
      {}
      <svg className="absolute top-16 right-[8%] w-14 h-14 text-primary opacity-20 hidden md:block" viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M20 4 L23 16 L35 16 L25 24 L29 36 L20 28 L11 36 L15 24 L5 16 L17 16 Z" />
      </svg>
      <svg className="absolute bottom-32 left-[6%] w-10 h-10 text-primary opacity-20 hidden md:block" viewBox="0 0 40 40" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
        <path d="M22 4 L10 22 L18 22 L14 36 L30 16 L22 16 Z" />
      </svg>

      <div className="container mx-auto max-w-[1440px] px-4 md:px-8 relative">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 mb-16 md:mb-20">
          <div className="md:col-span-8">
            <p className="font-mono text-xs md:text-sm uppercase tracking-[0.18em] text-primary mb-6">
              § VPNGENIX / INSIGHTS
            </p>
            <h2 className="font-default text-foreground leading-[0.92]" style={{
            fontFamily: "var(--font-sans)",
            fontSize: "clamp(2.5rem, 6vw, 5.5rem)",
            letterSpacing: "-0.025em",
            fontWeight: 700
          }}>
              Latest{" "}
              <span className="inline-block relative">
                <span className="relative inline-block bg-primary text-primary-foreground rounded-md px-4 py-1 rotate-2" style={{
                boxShadow: "5px 5px 0 var(--border)"
              }}>
                  Updates
                </span>
              </span>
              .
            </h2>
          </div>

          <div className="md:col-span-4 flex md:justify-end md:items-end">
            <Link to="/BlogsPage" className="group inline-flex items-center">
              <Button variant="ghost" className="bg-transparent border-2 border-dashed border-border text-foreground rounded-md px-5 py-2.5 font-mono text-xs uppercase tracking-[0.18em] font-semibold hover:bg-primary hover:text-primary-foreground">
                View All
                <svg className="ml-2 w-8 h-5 text-primary group-hover:text-primary-foreground" viewBox="0 0 60 20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M2 12 Q 15 4, 30 12 T 55 10" />
                  <path d="M48 4 L 55 10 L 49 16" />
                </svg>
              </Button>
            </Link>
          </div>
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <DevLogsConsumer />
        </PostsProvider>
      </div>

      {}
      <div className="relative mt-20 md:mt-28 border-t-2 border-border overflow-hidden">
        <div className="flex whitespace-nowrap py-4 animate-[ticker_60s_linear_infinite]">
          {[...Array(3)].map((_, repeatIdx) => <div key={repeatIdx} data-index={repeatIdx} className="flex shrink-0">
              {tickerItems.map((item, i) => <span key={`${repeatIdx}-${i}`} className="font-mono text-sm md:text-base uppercase tracking-[0.2em] text-muted-foreground font-semibold px-6 inline-flex items-center">
                  <span className="mr-6 text-primary">◆</span>
                  {item}
                </span>)}
            </div>)}
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </section>;
}